export default "__VITE_ASSET__CoHnMNzj__"